import { getTenantUrl } from 'api/CommonApi';

/**
 * Utilities for external navigation operations
 */

export interface NavigationConfig {
  basePath: string;
  developmentPort?: string;
  productionPort?: string;
}

/**
 * Generates dynamic URL for external navigation
 */
export const generateExternalUrl = async (
  path: string,
  tenantId?: string
): Promise<string> => {
  const { url } = await getTenantUrl(tenantId);
  return new URL(path, url).toString();
};

/**
 * Performs external navigation breaking out of React Router context
 */
export const navigateExternal = (url: string): void => {
  if (window.top) {
    window.top.location.href = url;
  } else {
    window.location.href = url;
  }
};

/**
 * Combined function for generating URL and navigating
 */
export const navigateToExternal = async (
  path: string,
  tenantId?: string
): Promise<void> => {
  const url = await generateExternalUrl(path, tenantId);
  navigateExternal(url);
};